import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Protected route component that checks if user is authenticated and has made a top-up
function ProtectedRoute() {
  const { isAuthenticated, loading, hasMadeTopUp } = useAuth();

  // If still loading auth state, show nothing (or could add a spinner here)
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but hasn't made a top-up, redirect to top-up page
  if (!hasMadeTopUp) {
    return <Navigate to="/top-up-required" replace />;
  }

  // If authenticated and has made a top-up, render the child routes
  return <Outlet />;
}

export default ProtectedRoute;
